import { IFilters } from '../../_models/commonInterface'
import {
  IDeleteIds,
  IGetFacilityParams,
  IGetRoleParams,
  IInviteFromSuperAdminUserParams,
  IUserListFilters,
} from '../../_models/superAdmin/businessUsersInterface'
import { get, post, put } from './../apiServices'

const getUsersList = async (filters: IUserListFilters) => {
  const response = await get('/super-admin/invite-user/list', filters)
  return response
}
const getInviteBusinessList = async (filters: IFilters) => {
  const response = await get('super-admin/role/business/list', filters)
  return response
}
const getBusinessRolesList = async (params: IGetRoleParams) => {
  const response = await get('super-admin/role/list', params)
  return response
}
const getFacilityList = async (selectedBusinessId: IGetFacilityParams) => {
  const response = await get('super-admin/invite-user/business/facility/list', selectedBusinessId)
  return response
}
const getRolePermissions = async (roleId: number | null) => {
  const response = await get(`super-admin/invite-user/role/${roleId}`)
  return response
}
const getAllPermissions = async () => {
  const response = await get('super-admin/permissions')
  return response
}
const checkIfUserExits = async (params: { email: string }) => {
  const response = await get('super-admin/invite-user/user-details', params)
  return response
}
const inviteUserFromSuperAdmin = async (params: IInviteFromSuperAdminUserParams) => {
  const response = await post('super-admin/invite-user', params)
  return response
}

const getBusinessList = async () => {
  const response = await get('/super-admin/invite-user/business/list')
  return response
}
const reInviteUser = async (userId: number) => {
  const response = await post(`/super-admin/re-invite-user/${userId}`)
  return response
}
const editInvitedUserFromSuperAdmin = async (
  invitationId: number | null,
  params: IInviteFromSuperAdminUserParams,
) => {
  const response = await put(`super-admin/invite-user/${invitationId}`, params)
  return response
}
const invitedUserDetails = async (invitationId: number) => {
  const response = await get(`super-admin/invite-user/details/${invitationId}`)
  return response
}

const deleteUser = async (ids: IDeleteIds) => {
  const response = await post('/super-admin/invite-user/delete', ids)

  return response
}
const businessUsersService = {
  getUsersList,
  getInviteBusinessList,
  getBusinessRolesList,
  getFacilityList,
  getRolePermissions,
  getAllPermissions,
  checkIfUserExits,
  inviteUserFromSuperAdmin,
  getBusinessList,
  reInviteUser,
  editInvitedUserFromSuperAdmin,
  invitedUserDetails,
  deleteUser,
}
export default businessUsersService
